import {normalize} from '@/lib/utils'

function bigrams(text: string): Set<string> {
  const grams = new Set<string>()
  for (let i = 0; i < text.length - 1; i++) grams.add(text.slice(i, i + 2))
  return grams
}

/** Share of the query's bigrams found in the haystack (both normalized), 0..1. */
export function bigramSimilarity(query: string, haystack: string): number {
  const qGrams = bigrams(normalize(query))
  if (qGrams.size === 0) return 0
  const hGrams = bigrams(normalize(haystack))
  let hits = 0
  for (const gram of qGrams) if (hGrams.has(gram)) hits++
  return hits / qGrams.size
}

/** `cedula` es opcional: el selector del afectado de un accidente no recibe cédulas de terceros. */
function matchPerson(person: {name: string; last_name: string; cedula?: string}, query: string): number {
  const haystack = `${person.name} ${person.last_name} ${person.cedula ?? ''}`
  if (normalize(haystack).includes(normalize(query))) return 2
  const similarity = bigramSimilarity(query, haystack)
  return similarity >= 0.5 ? 1 + similarity / 2 : 0
}

export function rankMatches<T extends {name: string; last_name: string; cedula?: string}>(
  people: T[],
  query: string,
  exclude?: (person: T) => boolean
): T[] {
  if (!query.trim()) return []
  return people
    .map((person) => ({person, score: matchPerson(person, query)}))
    .filter((m) => m.score > 0 && !exclude?.(m.person))
    .sort((a, b) => b.score - a.score)
    .slice(0, 6)
    .map((m) => m.person)
}
